<app-loader [fullPage]="true"
            [loaderId]="loaderId">
  @if(initialized && !block) {
  <router-outlet></router-outlet>
  }
  @if(block) {
  <app-work-in-progress [subTitle]="workInProgressTitle">
  </app-work-in-progress>
  }
</app-loader>
<ng-container #msalRedirect></ng-container>